import CardAguardar from "_+_Portal/_-_Autocheckin/components/genericos/CardAguardar/CardAguardar";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { useContext, useEffect, useState } from "react";
import { ContainerTurnosConPresente } from "./localStyle";
import { setActualNuevoLabo } from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import TurnoSinRecepcion from "_+_Portal/_-_Autocheckin/components/genericos/TurnoSinRecepcion/TurnoSinRecepcion";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";

const TurnosConPresente = () => {
  const { turnosSeleccionadosState, laboratorioDispatch, pasoDispatch } =
    useContext(AutocheckContext);
  const { modalDispatch } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const listaTurnos = turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];
  const presentes = (listaTurnos ?? []).filter(
    (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
  );
  const turnosRecepcionables = (listaTurnos ?? []).filter(
    (turno) => turno.estadoProtocolo >= 1 && turno.estadoProtocolo < 4,
  );
  const handleClick = (index) => {
    setActualNuevoLabo(index)(laboratorioDispatch);
    setPaso("TurnoRecepcionadoLabo")(pasoDispatch);
  };
  const recepcionarme = () => {
    setPaso("TurnosDelDiaLabo")(pasoDispatch);
    hideModal()(modalDispatch);
  };
  const salirSinRecepcion = () => {
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (turnosRecepcionables.length > 0) {
      showModal(
        <TurnoSinRecepcion
          title={"Turnos sin recepcionar"}
          desc="Cuenta con otros turnos para el día de hoy sin recepcionar."
          textBtnOne={"Salir sin recepcionar"}
          textBtnTwo="Recepcionarme"
          handleClick={{
            btnTwoClick: recepcionarme,
            btnOneClick: salirSinRecepcion,
          }}
        />,
      )(modalDispatch);
    }
  }, []);

  return (
    <LayoutPasos type={"no-circle"} title={"AUTO CHECK IN"}>
      {loading ? (
        <Loading
          dataLoading={loading}
          color="c-white"
          descripcion={"Cargando..."}
        />
      ) : (
        <ContainerTurnosConPresente
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
        >
          {presentes.map((turno, key) => {
            return (
              <CardAguardar
                horaTurno={turno.hora}
                nombreTurno={turno.especialidad}
                sedeTurno={turno.centro}
                flgSoloConsulta={turno.flgSoloConsulta}
                medico={turno.medico}
                consultorioTurno={!turno?.consultorio ? "" : turno?.consultorio}
                btnDisable={false}
                handleClick={() => {
                  handleClick(key);
                }}
                key={key}
                index={key}
              />
            );
          })}
          {turnosRecepcionables.length > 0 ? (
            <button className="turnos" onClick={recepcionarme}>
              Turnos sin recepción
            </button>
          ) : (
            ""
          )}
        </ContainerTurnosConPresente>
      )}
    </LayoutPasos>
  );
};

export default TurnosConPresente;
